import customFetchBase from "../../../../principal/customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";

export const firmaBoletaApi = createApi({
  reducerPath: "firmaBoletaApi",
  baseQuery: customFetchBase,
  tagTypes: ["Boletas"],
  endpoints: () => ({}),
});
